// extracted by mini-css-extract-plugin
export var createdDate = "_ll-1";
export var divider = "_ll-2";
export var headerDivider = "_ll-3";
export var messagesCard = "_ll-0";
export var messagesContainer = "_ll-7";
export var messagesContainerWrapper = "_ll-4";
export var pointerCapturingButtonBoxes = "_ll-a";
export var showLeftPanelButton = "_ll-9";
export var showMoreButton = "_ll-c";
export var showMoreButtonContainer = "_ll-b";
export var summaryTitle = "_ll-6";
export var systemMessageCardWrapper = "_ll-d";
export var topButtons = "_ll-8";
export var withPadding = "_ll-5";